import React, { useState, useEffect, useCallback } from "react";
// CSS alag rahegi - apni existing file import karo
import "../Content/CSS/FlightAddon.css";


const AedIcon = () => <span style={{ fontFamily: "sans-serif" }}>&#xea;</span>;

// ══════════════════════════════════════════════
// BAGGAGE OFFCANVAS COMPONENT
// ══════════════════════════════════════════════

// // ─── Baggage Icon (inline SVG, no external image needed) ───
const BaggageIcon = ({ weight }) => {
  // weight ke hisaab se size thoda scale karte hain visually
  const sizeMap = { "3": 20, "5": 24, "8": 26, "10": 28, "15": 32, "20": 36, "30": 40 };
  const size = sizeMap[weight] || 22;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="7" width="16" height="14" rx="2" stroke="#1d4ed8" strokeWidth="1.8" fill="#eff6ff" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" stroke="#1d4ed8" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="8" y1="11" x2="8" y2="17" stroke="#1d4ed8" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="16" y1="11" x2="16" y2="17" stroke="#1d4ed8" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

function getBaggageWeight(description) {
  if (!description) return null;
  const match = description.match(/(\d+)\s*kgs?/i);
  return match ? match[1] : null;
}
// ─── BaggageRow ───────────────────────────────
function BaggageRow({ baggage, paxType, paxIndex, optionIndex, isChecked, onChange, toAed }) {
  const inputId = `baggage-pax-${paxType}-${paxIndex}-baggage-${optionIndex + 1}`;
  const name = `baggageoption-${paxType}-${paxIndex}`;
  const aedPrice = toAed(baggage.Price);
  const weight = getBaggageWeight(baggage.Description);

  return (
    <div className="baggage_row">
      <div className="baggage_col">
        <div className="baggage_img">
          <BaggageIcon weight={weight} />
        </div>
        <div>
          <span className="baggage_desc">{baggage.Description}</span>
          <span className="baggage_price">
            {aedPrice ? <><AedIcon /> {Number(aedPrice).toLocaleString("en-AE")}</> : <>₹{baggage.Price}</>}
          </span>
        </div>
      </div>
      <div className="baggage_col">
        <input
          className="baggage_rbtn"
          id={inputId}
          type="checkbox"
          name={name}
          checked={isChecked}
          data-price={baggage.Price}
          data-code={baggage.Code}
          onChange={() => onChange(paxType, paxIndex, baggage)}
        />
        <label htmlFor={inputId}></label>
      </div>
    </div>
  );
}

// ─── BaggagePaxBlock ──────────────────────────
function BaggagePaxBlock({ label, paxType, paxIndex, baggageList, selection, onToggle, collapseId, expanded, toAed }) {
  const [open, setOpen] = useState(expanded);
  const selectedBaggage = selection[`${paxType}-${paxIndex}`];
  const price = selectedBaggage ? selectedBaggage.Price : 0;
  const aedPrice = toAed(price);

  return (
    <>
      <div
        className="baggage_pax"
        onClick={() => setOpen((o) => !o)}
        style={{ cursor: "pointer" }}
      >
        <div><span className="lbl">{label}</span></div>
        <div>
          <span className="lbl baggage-price-label">
            {aedPrice ? <><AedIcon /> {Number(aedPrice).toLocaleString("en-AE")}</> : <>₹{price}</>}
          </span>
          <span className="lbl2">Added to fare</span>
        </div>
      </div>
      <div className="baggage_list" id={collapseId}>
        <div className="baggage_list">
          {baggageList.map((baggage, idx) => (
            <BaggageRow
              key={idx}
              baggage={baggage}
              paxType={paxType}
              paxIndex={paxIndex}
              optionIndex={idx}
              isChecked={selectedBaggage?.Code === baggage.Code}
              onChange={onToggle}
              toAed={toAed}
            />
          ))}
        </div>
      </div>
    </>
  );
}

// ─── BaggageOffcanvas (main) ──────────────────
export function BaggageOffcanvas({
  isInternational = false, // SSReturnBaggageINTB2C
  adultCount = 0,          // passed down from AddonManager (from FlightReview)
  childCount = 0,
  inrToAed = null,
  ssrData = null,           // shared Trip/SSR response from AddonManager
  ssrLoading = false,
  ssrError = null,
  onDone,
}) {
  const [baggageData, setBaggageData] = useState({
    BaggageList: [],
    ReturnBaggageList: [],
    sourceCity: "",
    destinationCity: "",
  });

  // selection: { "adult-1": { Code, Price }, "child-1": {...}, "returnadult-1": {...} }
  const [selection, setSelection] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("baggageSelection") || "{}");
    } catch {
      return {};
    }
  });
  const [childSelection, setChildSelection] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("baggageSelectionChild") || "{}");
    } catch {
      return {};
    }
  });

  const toAed = (inrAmount) => {
    if (!inrToAed) return null;
    return (Number(inrAmount || 0) * inrToAed).toFixed(2);
  };

  useEffect(() => {
    if (!ssrData) return;
    setBaggageData({
      BaggageList: ssrData.BaggageList || [],
      ReturnBaggageList: ssrData.ReturnBaggageList || [],
      sourceCity: ssrData.BaggageList?.[0]?.Origin || "",
      destinationCity: ssrData.BaggageList?.[0]?.Destination || "",
    });
  }, [ssrData]);

  const loading = ssrLoading;
  const error = ssrError;

  const handleToggle = useCallback((paxType, paxIndex, baggage) => {
    const key = `${paxType}-${paxIndex}`;
    const isChild = paxType.includes("child");

    const setter = isChild ? setChildSelection : setSelection;
    const storageKey = isChild ? "baggageSelectionChild" : "baggageSelection";

    setter((prev) => {
      const next = { ...prev };
      // Toggle: if same code already selected → deselect
      if (next[key]?.Code === baggage.Code) {
        delete next[key];
      } else {
        next[key] = { Code: baggage.Code, Price: baggage.Price };
      }
      try {
        localStorage.setItem(storageKey, JSON.stringify(next));
      } catch {}

      // Sync hidden inputs
      syncBaggageInputs(next, isChild);
      return next;
    });
  }, []);

  function syncBaggageInputs(sel, isChild) {
    const str = Object.entries(sel)
      .map(([key, val]) => `${key}-${val.Code}-${val.Price}`)
      .join("|");
    const inputId = isChild ? "childbaggage" : "adultbaggage";
    const el = document.getElementById(inputId);
    if (el) el.value = str;
  }

  const totalPrice = [
    ...Object.values(selection),
    ...Object.values(childSelection),
  ].reduce((sum, v) => sum + (Number(v.Price) || 0), 0);

 const handleDone = () => {
  const el = document.getElementById("BaggagePrice");
  if (el) el.value = totalPrice;
  const merged = { ...selection, ...childSelection }; 
  if (onDone) onDone(totalPrice, merged); 
};

  const { BaggageList, ReturnBaggageList } = baggageData;
  const adults = Array.from({ length: adultCount }, (_, i) => i + 1);
  const children = Array.from({ length: childCount }, (_, i) => i + 1);

  return (
    <div className="offcanvas offcanvas-end show" tabIndex="-1" id="baggage-offcanvas" style={{ width: 500, maxWidth: "96vw" }}>
      <div className="offcanvas-header border-bottom">
        <h5>Add in-flight baggage to your journey</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
      </div>
      <div className="offcanvas-body p-4">
        {loading && <div className="text-center py-5"><div className="spinner-border" /></div>}
        {!loading && error && <div className="text-center text-danger py-4">{error}</div>}

        {!loading && !error && (
          <div className="adon_wrap">
            <div className="adon_left" id="SourceDestiBaggage">
              {baggageData.sourceCity && (
                <div className="vtab_btn active">
                  <span className="vtab_trip">
                    {baggageData.sourceCity}
                    <i className="bi bi-arrow-right" />
                    {baggageData.destinationCity}
                  </span>
                  <span className="vtab_traveler">
                    <span>{Object.keys({ ...selection, ...childSelection }).length}</span>
                    /{adultCount + childCount}
                  </span>
                </div>
              )}
            </div>
            <div className="adon_right">
              <div id="pexdetails">
                {/* Adults - Onward */}
                {adults.map((i) => (
                  <BaggagePaxBlock
                    key={`adult-${i}`}
                    label={`Adult ${i}`}
                    paxType="adult"
                    paxIndex={i}
                    baggageList={BaggageList}
                    selection={selection}
                    onToggle={handleToggle}
                    collapseId={`baggage-onward-pax-${i}`}
                    expanded={i === 1}
                    toAed={toAed}
                  />
                ))}
                {/* Adults - Return (if international) */}
                {isInternational && ReturnBaggageList.length > 0 &&
                  adults.map((i) => (
                    <BaggagePaxBlock
                      key={`returnadult-${i}`}
                      label={`Adult ${i} - Return`}
                      paxType="returnadult"
                      paxIndex={i}
                      baggageList={ReturnBaggageList}
                      selection={selection}
                      onToggle={handleToggle}
                      collapseId={`baggage-return-pax-${i}`}
                      expanded={false}
                      toAed={toAed}
                    />
                  ))}
                {/* Children - Onward */}
                {children.map((i) => (
                  <BaggagePaxBlock
                    key={`child-${i}`}
                    label={`Child ${i}`}
                    paxType="child"
                    paxIndex={i}
                    baggageList={BaggageList}
                    selection={childSelection}
                    onToggle={handleToggle}
                    collapseId={`baggage-onward-child-${i}`}
                    expanded={false}
                    toAed={toAed}
                  />
                ))}
                {/* Children - Return (if international) */}
                {isInternational && ReturnBaggageList.length > 0 &&
                  children.map((i) => (
                    <BaggagePaxBlock
                      key={`returnchild-${i}`}
                      label={`Child ${i} - Return`}
                      paxType="returnchild"
                      paxIndex={i}
                      baggageList={ReturnBaggageList}
                      selection={childSelection}
                      onToggle={handleToggle}
                      collapseId={`baggage-return-child-${i}`}
                      expanded={false}
                      toAed={toAed}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="offcanvas-bottom p-3 shadow">
        <div className="d-flex justify-content-end align-items-center gap-3">
          <span className="fs-5 fw-semibold">
            {inrToAed ? (
              <><AedIcon /> {Number(toAed(totalPrice)).toLocaleString("en-AE")}</>
            ) : (
              <>₹{totalPrice}</>
            )}
          </span>
          <button
            className="btn btn-primary px-4"
            id="btnbaggage"
            onClick={handleDone}
            data-bs-dismiss="offcanvas"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════
// MEAL OFFCANVAS COMPONENT
// ══════════════════════════════════════════════

const MealIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#059669" strokeWidth="1.8" fill="#ecfdf5" />
    <path d="M9 8v4a1.5 1.5 0 0 0 3 0V8" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="9" y1="8" x2="9" y2="16" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M15 8v3a1.5 1.5 0 0 0 3 0V8M16.5 8v8" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// ─── MealRow ──────────────────────────────────
function MealRow({ meal, paxType, paxIndex, mealIndex, isReturn, isChecked, onChange, airlineCode, toAed }) {
  const prefix = isReturn
    ? `meal-${paxType}-${paxIndex}-return`
    : `meal-${paxType}-${paxIndex}`;
  const inputId = `${prefix}-${mealIndex}`;
  const name = isReturn
    ? `mealoption-return-${paxType}-${paxIndex}`
    : `mealoption-${paxType}-${paxIndex}`;
  const aedPrice = toAed(meal.MealAmount);

  return (
    <div className="meal_row">
      <div className="meal_col">
        <div className="meal_img">
          <MealIcon />
       </div>
        <div>
          <span className="meal_desc">{meal.Description}</span>
          <span className="meal_price">
            {aedPrice ? <><AedIcon /> {Number(aedPrice).toLocaleString("en-AE")}</> : <>₹{meal.MealAmount}</>}
          </span>
        </div>
      </div>
      <div className="meal_col">
        <input
          className="meal_rbtn"
          id={inputId}
          type="checkbox"
          name={name}
          checked={isChecked}
          data-price={meal.MealAmount}
          data-code={meal.Code}
          onChange={() => onChange(paxType, paxIndex, isReturn, meal)}
        />
        <label htmlFor={inputId}></label>
      </div>
    </div>
  );
}

// ─── MealPaxBlock ─────────────────────────────
function MealPaxBlock({
  label,
  paxType,
  paxIndex,
  isReturn,
  mealList,
  selection,
  onToggle,
  airlineCode,
  toAed,
}) {
  const [open, setOpen] = useState(!isReturn);
  const key = `${paxType}-${paxIndex}-${isReturn ? "return" : "onward"}`;
  const selectedMeal = selection[key];
  const price = selectedMeal ? selectedMeal.MealAmount : 0;
  const aedPrice = toAed(price);
  const collapseId = isReturn
    ? `meal-return-pax-${paxType}-${paxIndex}-return`
    : `meal-onward-pax-${paxType}-${paxIndex}`;

  return (
    <>
      <div
        className="meal_pax"
        onClick={() => setOpen((o) => !o)}
        style={{ cursor: "pointer" }}
      >
        <div><span className="lbl">{label}</span></div>
        <div>
          <span className={`lbl meal-price-label ${paxType}-price`}>
            {aedPrice ? <><AedIcon /> {Number(aedPrice).toLocaleString("en-AE")}</> : <>₹{price}</>}
          </span>
          <span className="lbl2">Added to fare</span>
        </div>
      </div>
      <div className={`collapse${open ? " show" : ""}`} id={collapseId}>
        <div className={`meal_list meal-list-${paxType}${isReturn ? "-return" : ""}`}>
          {mealList.map((meal, idx) => (
            <MealRow
              key={idx}
              meal={meal}
              paxType={paxType}
              paxIndex={paxIndex}
              mealIndex={idx}
              isReturn={isReturn}
              isChecked={selectedMeal?.Code === meal.Code}
              onChange={onToggle}
              airlineCode={airlineCode}
              toAed={toAed}
            />
          ))}
        </div>
      </div>
    </>
  );
}

// ─── MealOffcanvas (main) ────
export function MealOffcanvas({
  adultCount = 0,  
  childCount = 0,
  inrToAed = null,
  ssrData = null,  
  ssrLoading = false,
  ssrError = null,
  onDone,
}) {
  const [mealData, setMealData] = useState({
    MealList: [],
    ReturnMealList: [],
    airlineCode: "",
    sourceCity: "",
    destinationCity: "",
  });

  // selection: { "adult-1-onward": mealObj, "adult-1-return": mealObj }
  const [selection, setSelection] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mealSelection") || "{}");
    } catch {
      return {};
    }
  });

  const toAed = (inrAmount) => {
    if (!inrToAed) return null;
    return (Number(inrAmount || 0) * inrToAed).toFixed(2);
  };

  useEffect(() => {
    if (!ssrData) return;
    const seatList = ssrData.AirlineSeatMasterList || [];
    setMealData({
      MealList: ssrData.MealList || [],
      ReturnMealList: ssrData.ReturnMealList || [],
      airlineCode: seatList[0]?.AirlineCode || "",
      sourceCity: ssrData.MealList?.[0]?.Origin || "",
      destinationCity: ssrData.MealList?.[0]?.Destination || "",
    });
  }, [ssrData]);

  const loading = ssrLoading;
  const error = ssrError;

  const handleToggle = useCallback((paxType, paxIndex, isReturn, meal) => {
    const key = `${paxType}-${paxIndex}-${isReturn ? "return" : "onward"}`;

    setSelection((prev) => {
      const next = { ...prev };
      if (next[key]?.Code === meal.Code) {
        delete next[key]; // deselect
      } else {
        next[key] = meal;
      }
      try {
        localStorage.setItem("mealSelection", JSON.stringify(next));
      } catch {}

      syncMealInputs(next);
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adultCount, childCount]);

  function syncMealInputs(sel) {
    function buildString(type, maxCount, isRet) {
      const parts = [];
      for (let i = 1; i <= maxCount; i++) {
        const k = `${type}-${i}-${isRet ? "return" : "onward"}`;
        if (sel[k]) {
          const prefix = isRet ? `${type}-return-${i}` : `${type}-${i}`;
          parts.push(`${prefix}-${sel[k].Code}-${sel[k].MealAmount}`);
        }
      }
      return parts.join("|");
    }

    const adultOnward = buildString("adult", adultCount, false);
    const adultReturn = buildString("adult", adultCount, true);
    const childOnward = buildString("child", childCount, false);
    const childReturn = buildString("child", childCount, true);

    const setInput = (id, val) => {
      const el = document.getElementById(id);
      if (el) el.value = val;
    };

    setInput("adultMeal", adultOnward);
    setInput("adultReturnMeal", adultReturn);
    setInput("childMeal", childOnward);
    setInput("childReturnMeal", childReturn);
  }

  const totalPrice = Object.values(selection).reduce(
    (sum, m) => sum + (Number(m?.MealAmount) || 0),
    0
  );

  const handleDone = () => {
    const el = document.getElementById("MealPrice");
    if (el) el.value = totalPrice;
    if (onDone) onDone(totalPrice, selection);
  };

  const { MealList, ReturnMealList, airlineCode } = mealData;
  const adults = Array.from({ length: adultCount }, (_, i) => i + 1);
  const children = Array.from({ length: childCount }, (_, i) => i + 1);
  const checkedCount = Object.keys(selection).length;

  return (
    <div className="offcanvas offcanvas-end show" tabIndex="-1" id="meal-offcanvas" style={{ width: 500, maxWidth: "96vw" }}>
      <div className="offcanvas-header border-bottom">
        <h5>Add in-flight meals to your journey</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
      </div>
      <div className="offcanvas-body p-4">
        {loading && <div className="text-center py-5"><div className="spinner-border" /></div>}
        {!loading && error && <div className="text-center text-danger py-4">{error}</div>}

        {!loading && !error && (
          <div className="adon_wrap">
            <div className="adon_left" id="SourceDestiMeal">
              {mealData.sourceCity && (
                <div className="vtab_btn active">
                  <span className="vtab_trip">
                    {mealData.sourceCity}
                    <i className="bi bi-arrow-right" />
                    {mealData.destinationCity}
                  </span>
                  <span className="vtab_traveler">
                    <span>{checkedCount}</span>/{adultCount + childCount}
                  </span>
                </div>
              )}
            </div>
            <div className="adon_right">
              <div id="pexdetailsmeal">
                {/* Adults Onward */}
                {adults.map((i) => (
                  <MealPaxBlock
                    key={`adult-${i}-onward`}
                    label={`Adult ${i}`}
                    paxType="adult"
                    paxIndex={i}
                    isReturn={false}
                    mealList={MealList}
                    selection={selection}
                    onToggle={handleToggle}
                    airlineCode={airlineCode}
                    toAed={toAed}
                  />
                ))}
                {/* Adults Return */}
                {ReturnMealList.length > 0 &&
                  adults.map((i) => (
                    <MealPaxBlock
                      key={`adult-${i}-return`}
                      label={`Return Adult ${i}`}
                      paxType="adult"
                      paxIndex={i}
                      isReturn={true}
                      mealList={ReturnMealList}
                      selection={selection}
                      onToggle={handleToggle}
                      airlineCode={airlineCode}
                      toAed={toAed}
                    />
                  ))}
                {/* Children Onward */}
                {children.map((i) => (
                  <MealPaxBlock
                    key={`child-${i}-onward`}
                    label={`Child ${i}`}
                    paxType="child"
                    paxIndex={i}
                    isReturn={false}
                    mealList={MealList}
                    selection={selection}
                    onToggle={handleToggle}
                    airlineCode={airlineCode}
                    toAed={toAed}
                  />
                ))}
                {/* Children Return */}
                {ReturnMealList.length > 0 &&
                  children.map((i) => (
                    <MealPaxBlock
                      key={`child-${i}-return`}
                      label={`Return Child ${i}`}
                      paxType="child"
                      paxIndex={i}
                      isReturn={true}
                      mealList={ReturnMealList}
                      selection={selection}
                      onToggle={handleToggle}
                      airlineCode={airlineCode}
                      toAed={toAed}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="offcanvas-bottom p-3 shadow">
        <div className="d-flex justify-content-end align-items-center gap-3">
          <span className="fs-5 fw-semibold" id="total-Mealprice">
            {inrToAed ? (
              <><AedIcon /> {Number(toAed(totalPrice)).toLocaleString("en-AE")}</>
            ) : (
              <>₹{totalPrice}</>
            )}
          </span>
          <button
            className="btn btn-primary px-4"
            id="btnMeal"
            onClick={handleDone}
            data-bs-dismiss="offcanvas"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}